import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, shareReplay, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';

const { DEVELOPER_PORTAL_URL } = environment;

export interface EncryptionSecrets {
  aesKey: string;
  secretKey: string;
}

@Injectable({
  providedIn: 'root'
})
export class EncryptionSecretService {
  private encryptionSecretsCache = new Map<string, Observable<EncryptionSecrets>>();

  constructor(
    private readonly http: HttpClient,
    private readonly storageService: StorageService,
    private readonly router: Router
  ) { }

  loadEncryptionSecrets(merchantId?: string): Observable<EncryptionSecrets> {
    const cacheKey = merchantId ?? '__self__';
    let cached = this.encryptionSecretsCache.get(cacheKey);
    if (!cached) {
      const url = merchantId
        ? `${DEVELOPER_PORTAL_URL}/pg-encryption-key?merchantId=${encodeURIComponent(merchantId)}`
        : `${DEVELOPER_PORTAL_URL}/pg-encryption-key`;
      cached = this.http
        .get<EncryptionSecrets>(url)
        .pipe(
          catchError(this.handleError<EncryptionSecrets>()),
          shareReplay({ bufferSize: 1, refCount: false })
        );
      this.encryptionSecretsCache.set(cacheKey, cached);
    }
    return cached;
  }

  clearEncryptionSecrets(): void {
    this.encryptionSecretsCache.clear();
  }

  private handleError<T>(result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      if (error.status === 401) {
        this.storageService.clean();
      }
      result = error?.error;
      return throwError(() => result);
    };
  }
}
